import * as Dialog from "../framework/dialog";
import { getUITranslation } from "../utils/get_ui_translation";

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".js-select-trainees-page")) {
    document.querySelector("select[name='js_customer_id']")?.addEventListener("change", onCustomerSelected);
    document.querySelector("input[name='js_hours_on_working_time']")?.addEventListener("change", onCustomerSelected);
    document.querySelector("select[name='js_on_working_time']")?.addEventListener("change", onCustomerSelected);
    document.querySelectorAll(".js-create-trainee")?.forEach((element) => {
      element.addEventListener("click", onClickCreateTrainee);
    });
  }
});

function onClickCreateTrainee(e) {
  const customerSelector = document.querySelector("select[name='js_customer_id']");

  // We don't submit if no customer is selected
  if (customerSelector && customerSelector.value === "") {
    e.preventDefault();
    e.stopPropagation();
    Dialog.alertInfo("", getUITranslation("Veuillez sélectionner ou créer un client en cliquant sur 'CHOIX DU CLIENT'"));
  }
}

function onCustomerSelected() {
  const customerSelector = document.querySelector("select[name='js_customer_id']");
  const workingTimeSelector = document.querySelector("select[name='js_on_working_time']");
  const hoursOnWorkingTimeInput = document.querySelector("input[name='js_hours_on_working_time']");

  if (customerSelector) {
    document.querySelector("input[name=customer_id]").value = customerSelector.value;
  }

  if (workingTimeSelector) {
    document.querySelector("input[name=on_working_time]").value = workingTimeSelector.value;
  }

  if (hoursOnWorkingTimeInput) {
    document.querySelector("input[name=hours_on_working_time]").value = hoursOnWorkingTimeInput.value;
  }
}
